export default "__VITE_ASSET__6dda34fd__"